import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/p/$projectId/$branch/")({
  beforeLoad: ({ params }) => {
    if (params.branch !== "main") {
      throw redirect({
        to: "/p/$projectId/$branch/workbench/$view",
        params: { ...params, view: "changes" },
        search: {},
      });
    }
    throw redirect({
      to: "/p/$projectId/$branch/explorer",
      params,
      search: {},
    });
  },
});
